<div class="d-flex justify-content-between align-items-start mb-3">
  <div>
    <h4 class="mb-1">{{ 'Settings::WorkEnvironment:Skills:Title' | abpLocalization }}</h4>
    <p class="text-muted small mb-0">
      {{ 'Settings::WorkEnvironment:Skills:Subtitle' | abpLocalization }}
    </p>
  </div>
  <button type="button" class="btn btn-primary btn-sm" (click)="addNew.emit()">
    <i class="pi pi-plus me-2"></i>
    {{ 'Settings::WorkEnvironment:Skills:AddSkill' | abpLocalization }}
  </button>
</div>

<div class="card">
  <div class="card-body p-0">
    <app-base-list
      *ngIf="listConfig"
      [config]="listConfig"
      [data]="skills"
      [totalRecords]="skills.length"
      [loading]="loading"
      [paginator]="false"
      [rows]="1000" />
  </div>

  <div *ngIf="!loading" class="px-3 py-2 border-top text-muted small">
    {{ skills.length }}
    {{ 'Settings::WorkEnvironment:Skills:SkillCount' | abpLocalization }} &middot;
    {{ activeCount }}
    {{ 'Settings::WorkEnvironment:Skills:ActiveCount' | abpLocalization }}
  </div>
</div>

<ng-template #agentsTpl let-row>
  <span class="d-inline-flex align-items-center gap-1">
    <button
      type="button"
      class="btn btn-link btn-sm skill-list__agents-trigger"
      [attr.aria-label]="'Settings::WorkEnvironment:Skills:ShowAssignedAgents' | abpLocalization"
      [attr.aria-expanded]="agentsPopoverOpen && agentsPopoverSkillId === row.id"
      (click)="onAgentsClick(row, $event)">
      {{ row.agentCount ?? 0 }} {{ 'Settings::WorkEnvironment:Skills:AgentsLabel' | abpLocalization }}
    </button>
    <i
      *ngIf="!row.agentCount"
      class="pi pi-exclamation-triangle text-warning"
      [pTooltip]="'Settings::WorkEnvironment:Skills:NoAgentsWarningTooltip' | abpLocalization"
      tooltipPosition="top">
    </i>
  </span>
</ng-template>

<ng-template #nameTpl let-row>
  <span style="display:inline-block; max-width:50ch; white-space:normal; overflow-wrap:break-word;">
    {{ row.name }}
  </span>
</ng-template>

<ng-template #statusTpl let-row>
  <span *ngIf="row.isActive" class="badge rounded-pill d-inline-flex align-items-center gap-1 skill-status-badge--active fs-6 fw-normal px-2 py-1">
    <i class="pi pi-circle-fill" style="font-size: 0.45rem;"></i>
    {{ 'Settings::WorkEnvironment:Skills:StatusActive' | abpLocalization }}
  </span>
  <span *ngIf="!row.isActive" class="badge rounded-pill d-inline-flex align-items-center gap-1 skill-status-badge--inactive fs-6 fw-normal px-2 py-1">
    <i class="pi pi-circle-fill" style="font-size: 0.45rem;"></i>
    {{ 'Settings::WorkEnvironment:Skills:StatusInactive' | abpLocalization }}
  </span>
</ng-template>

<ng-template #actionsTpl let-row>
  <app-action-menu [items]="getMenuItems(row)" />
</ng-template>

<p-popover
  #agentsPopover
  [dismissable]="true"
  [focusOnShow]="false"
  styleClass="skill-list__agents-popover"
  (onShow)="onAgentsPopoverShow()"
  (onHide)="onAgentsPopoverHide()">
  <app-assigned-agents
    [agents]="popoverAgents"
    [loading]="popoverLoading"
    [loadingMore]="popoverLoadingMore"
    [totalCount]="popoverTotalCount"
    [title]="'Settings::WorkEnvironment:Skills:AssignedAgentsTitle' | abpLocalization"
    [emptyMessage]="'Settings::WorkEnvironment:Skills:NoAgentsAssignedYet' | abpLocalization"
    (loadMore)="onAgentsLoadMore()">
    @if (canViewAgentManagement) {
      <a
        appAssignedAgentsFooter
        class="skill-list__agents-link d-inline-flex align-items-center gap-1"
        [routerLink]="agentManagementLink"
        [queryParams]="agentsPopoverQueryParams">
        {{ 'Settings::WorkEnvironment:Skills:ViewAllAgents' | abpLocalization }}
        <i class="pi pi-arrow-right" aria-hidden="true"></i>
      </a>
    }
  </app-assigned-agents>
</p-popover>

<app-skill-manage-agents-dialog
  [visible]="showManageAgentsDialog"
  [skill]="selectedSkillForManage"
  (visibleChange)="showManageAgentsDialog = $event"
  (saved)="onManageAgentsSaved()" />
